import type { IServiceColumn } from "../functions/serviceViewmodel";

/**
 * Attributes shown on the service report page (ServiceReport.vue) and in the
 * service panel on the provider report (ServiceDetails.vue).
 *
 * Part of the persisted "directory" configuration (key: serviceReportColumns).
 * This one config drives BOTH the GraphQL selection and the rendering, so
 * adding, renaming, reordering or removing a field here is enough - no code
 * change. See README "Service report configuration".
 *
 * `column` is a dotted path resolved against the service record. `id`, `name`
 * and the provider ref (dataModel.providerRefOnService) are always queried
 * regardless of this config - the breadcrumb and the cart need them.
 *
 * Defaults cover every real Services field in the isidore-acc-v13 model except
 * `service_providers` (shown in the info card via serviceProviderReportColumns),
 * `contactInformation` (the contact block) and `beneficiary`. Internal
 * `mg_*` / `*_agg` / `*_groupBy` fields are deliberately excluded.
 */
export const initialServiceReportColumns: IServiceColumn[] = [
  { label: "Id:", column: "id" },
  { label: "Name:", column: "name" },
  { label: "Acronym:", column: "acronym" },
  { label: "Description:", column: "description", type: "longtext" },
  { label: "Description URL:", column: "descriptionUrl", type: "hyperlink" },
  { label: "Device:", column: "device" },
  { label: "Device System:", column: "deviceSystem" },
  {
    label: "Access Description URL:",
    column: "accessDescriptionUrl",
    type: "hyperlink",
  },
  { label: "Unit of Access:", column: "unitOfAccess" },
  { label: "Access Description:", column: "accessDescription" },
  { label: "Unit Cost:", column: "unitCost" },
  { label: "Unit Theme:", column: "unitTheme" },
  {
    label: "Service Type:",
    column: "serviceTypes",
    type: "mref",
    subColumn: "serviceCategory.name",
  },
  { label: "TRL:", column: "tRL", type: "ref" },
  /** Taxons has no `label` column - selecting one would fail the whole query. */
  { label: "Taxon:", column: "taxon", type: "ref", refFields: ["name"] },
  { label: "Pathogen:", column: "pathogen" },
  { label: "Risk Group:", column: "riskGroup" },
  { label: "Availability:", column: "availability" },
  { label: "Method Category:", column: "methodCategory" },
  { label: "Model Species:", column: "modelSpecies" },
  { label: "Model Type:", column: "modelType" },
  { label: "Key Words:", column: "keyWords" },
  { label: "Work Package:", column: "wP" },
  { label: "Issued Date:", column: "issuedDate" },
  { label: "Modified Date:", column: "modifiedDate" },
];

export default initialServiceReportColumns;
